import { UserListItem, UserListItemProps, TabsContent } from '@app/shared/ui/molecules/Friends';
import { UserList } from './';
import { cn } from '@app/shared/utils/common';
import { LeaderboardTypeFilter } from '@app/store/slices/friends/friendsTypes';

interface CookiesTabProps {
  users: UserListItemProps[];
  isUsersLoading: boolean;
  myUser?: UserListItemProps;
}

export function CookiesTab({ users, isUsersLoading, myUser }: CookiesTabProps) {
  return (
    <TabsContent value={LeaderboardTypeFilter.COOKIE}>
      <div className="flex h-full flex-col">
        <div className="relative flex-1 overflow-hidden rounded-xl">
          <div className={cn('flex h-[calc(100%-30px)] flex-col overflow-auto', 'scrollbar-hide')}>
            <UserList users={users} isUsersLoading={isUsersLoading} className="flex-1" />
          </div>

          {myUser && (
            <div className="absolute bottom-8 left-0 right-0 bg-[#9ecdff]">
              <UserListItem {...myUser} isMe />
            </div>
          )}
        </div>
      </div>
    </TabsContent>
  );
}
